import { ProgressiveImage } from "@/components/progressive-image";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface ExpandableAvatarProps {
  src: string;
  imageHash?: string;
  name: string;
  initials: string;
}

export function ExpandableAvatar({
  src,
  imageHash,
  name,
  initials,
}: Readonly<ExpandableAvatarProps>) {
  return (
    <Dialog>
      <DialogTrigger>
        <Avatar
          size="xl"
          className="shrink-0 cursor-pointer ring-2 ring-primary ring-offset-2"
        >
          <ProgressiveImage
            imageHash={imageHash}
            className="absolute inset-0"
            placeholderClassName="inset-0 rounded-full object-cover"
          >
            {({ loaded, onLoad }) => (
              <AvatarImage
                src={src}
                alt={name}
                onLoadingStatusChange={(status) => {
                  if (status === "loaded") {
                    onLoad();
                  }
                }}
                className={cn(
                  "transition-opacity duration-300",
                  loaded ? "opacity-100" : "opacity-0",
                )}
              />
            )}
          </ProgressiveImage>

          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
      </DialogTrigger>
      <DialogContent className="p-0">
        <DialogTitle className="sr-only">{name}</DialogTitle>
        <DialogDescription className="sr-only">
          Full size profile photo of {name}
        </DialogDescription>
        <img
          src={src}
          alt={name}
          className={cn(
            "size-full rounded-lg object-contain transition-opacity duration-300",
          )}
        />
      </DialogContent>
    </Dialog>
  );
}
